/*
 * @Author: mars
 * @Date: 2021-11-30 21:03:23
 */
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '*',
    redirect: '/chat'
  },
  {
    name: 'user',
    component: () => import('@/view/user'),
    meta: {
      title: '会员中心'
    }
  },
  {
    name: 'cart',
    component: () => import('@/view/cart'),
    meta: {
      title: '购物车'
    }
  },
  {
    name: 'goods',
    component: () => import('@/view/goods'),
    meta: {
      title: '商品详情'
    }
  },
  {
    name: 'chat',
    component: () => import('@/view/chat'),
    meta: {
      title: '聊天'
    }
  }
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ routes });

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export {
  router
};
